import { render } from "./invitingEntrepreneurs.vue?vue&type=template&id=3fba4c1c"
import script from "./invitingEntrepreneurs.vue?vue&type=script&lang=js"
export * from "./invitingEntrepreneurs.vue?vue&type=script&lang=js"

import "./invitingEntrepreneurs.vue?vue&type=style&index=0&id=3fba4c1c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__